module.exports = __webpack_public_path__ + "static/media/nylasDisconnected.fcab7662.svg";